import { PhotoPrintsPdpDispatch } from '@ff-scene-plugins/photo-prints-redux/store';
import { setIsPhotoPrintsWindowOpen } from './_redux-ui';

export const close = (
    dispatch: PhotoPrintsPdpDispatch
) => {
    dispatch(setIsPhotoPrintsWindowOpen(false));
};